/* ═══════════════════════════════════════════════════════════
   Stolan Interactive v2 — BSB Gold Standard
   Counter animation, Social Proof Toasts, Live Map,
   Active Count, Menu Toggle, Scroll Reveals
   ═══════════════════════════════════════════════════════════ */

/* Stolan Interactive v2 */

/* 0. REMOVE "Start Here" FROM NAV (March 27, 2026) */
(function(){
  document.querySelectorAll(".nav-links a").forEach(function(a){
    if(a.textContent.trim()==="Start Here") a.closest("li").remove();
  });
})();


/* 1. COUNTER ANIMATION */
(function(){
  var counters = document.querySelectorAll('.stat-num[data-count]');
  if (!counters.length) return;
  var animateCounter = function(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (isNaN(target)) return;
    var duration = 2000, start = performance.now();
    var step = function(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);
      el.textContent = current.toLocaleString() + '+';
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  counters.forEach(function(c) { observer.observe(c); });
})();

/* 3. LIVE MAP — Canvas US outline with pulsing dots */
(function(){
  var mapEl = document.querySelector('.live-map');
  if (!mapEl) return;
  var canvas = document.createElement('canvas');
  canvas.width = 600;
  canvas.height = 360;
  Object.assign(canvas.style, {
    width: '100%',
    height: 'auto',
    borderRadius: '12px',
    background: 'rgba(0,0,0,0.3)'
  });
  var label = mapEl.querySelector('.live-map-label');
  if (label) {
    mapEl.insertBefore(canvas, label);
  } else {
    mapEl.appendChild(canvas);
  }
  var ctx = canvas.getContext('2d');
  var locations = [
    {x:120,y:80},{x:480,y:100},{x:150,y:200},{x:400,y:280},{x:300,y:150},
    {x:200,y:250},{x:350,y:200},{x:450,y:180},{x:250,y:120},{x:500,y:220},
    {x:180,y:300},{x:380,y:130},{x:280,y:260},{x:420,y:240},{x:160,y:160},
    {x:340,y:100},{x:520,y:150},{x:220,y:190},{x:460,y:260},{x:310,y:220}
  ];
  var dots = locations.map(function(loc) {
    return { x: loc.x, y: loc.y, pulse: Math.random() * Math.PI * 2, speed: 0.02 + Math.random() * 0.03, active: Math.random() > 0.3 };
  });
  var usOutline = [
    {x:90,y:62},{x:85,y:78},{x:78,y:100},{x:72,y:130},{x:75,y:160},{x:82,y:185},
    {x:95,y:210},{x:108,y:228},{x:115,y:240},{x:130,y:252},{x:155,y:258},{x:175,y:262},
    {x:195,y:260},{x:210,y:265},{x:230,y:275},{x:245,y:288},{x:260,y:300},{x:272,y:310},
    {x:280,y:315},{x:290,y:308},{x:305,y:298},{x:318,y:290},{x:340,y:285},{x:365,y:282},
    {x:385,y:278},{x:405,y:275},{x:420,y:270},{x:435,y:268},{x:445,y:275},{x:455,y:288},
    {x:462,y:305},{x:468,y:315},{x:472,y:308},{x:470,y:292},{x:465,y:275},{x:460,y:262},
    {x:468,y:248},{x:478,y:232},{x:490,y:215},{x:500,y:198},{x:504,y:182},{x:515,y:165},
    {x:522,y:144},{x:528,y:132},{x:535,y:118},{x:540,y:105},{x:542,y:95},{x:538,y:82},
    {x:530,y:72},{x:518,y:65},{x:500,y:60},{x:478,y:56},{x:455,y:52},{x:430,y:50},
    {x:405,y:48},{x:380,y:55},{x:372,y:48},{x:365,y:42},{x:375,y:38},{x:390,y:42},
    {x:400,y:46},{x:380,y:55},{x:355,y:52},{x:330,y:48},{x:305,y:46},{x:280,y:45},
    {x:255,y:46},{x:230,y:48},{x:205,y:50},{x:180,y:52},{x:155,y:55},{x:130,y:58},
    {x:110,y:60},{x:90,y:62}
  ];
  function drawOutline() {
    ctx.beginPath();
    ctx.moveTo(usOutline[0].x, usOutline[0].y);
    for (var i = 1; i < usOutline.length; i++) {
      ctx.lineTo(usOutline[i].x, usOutline[i].y);
    }
    ctx.closePath();
    ctx.strokeStyle = 'rgba(91,107,53,0.45)';
    ctx.lineWidth = 1.5;
    ctx.stroke();
    ctx.fillStyle = 'rgba(91,107,53,0.04)';
    ctx.fill();
  }
  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawOutline();
    dots.forEach(function(dot) {
      dot.pulse += dot.speed;
      if (dot.active) {
        var glowSize = 8 + Math.sin(dot.pulse) * 4;
        ctx.beginPath();
        ctx.arc(dot.x, dot.y, glowSize, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(91,107,53,0.15)';
        ctx.fill();
      }
      ctx.beginPath();
      ctx.arc(dot.x, dot.y, dot.active ? 3 : 2, 0, Math.PI * 2);
      ctx.fillStyle = dot.active ? '#5B6B35' : 'rgba(255,255,255,0.2)';
      ctx.fill();
      if (dot.active && Math.sin(dot.pulse) > 0.95) {
        var ringSize = 12 + (1 - Math.sin(dot.pulse)) * 20;
        ctx.beginPath();
        ctx.arc(dot.x, dot.y, ringSize, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(91,107,53,0.3)';
        ctx.lineWidth = 1;
        ctx.stroke();
      }
    });
    if (Math.random() < 0.005) {
      var idx = Math.floor(Math.random() * dots.length);
      dots[idx].active = !dots[idx].active;
    }
    requestAnimationFrame(draw);
  }
  draw();
})();

/* 4. ACTIVE FOUNDER COUNT */
(function(){
  var activeEl = document.getElementById('activeCount');
  if (!activeEl) return;
  var count = parseInt(activeEl.textContent, 10) || 14;
  function fluctuate() {
    var change = Math.random() > 0.5 ? 1 : -1;
    count = Math.max(8, Math.min(22, count + change));
    activeEl.textContent = count;
    setTimeout(fluctuate, 8000 + Math.random() * 12000);
  }
  setTimeout(fluctuate, 10000);
})();

/* 5. MENU TOGGLE */
(function(){
  var btn = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.nav-links');
  if (!btn || !nav) return;
  btn.addEventListener('click', function() {
    nav.classList.toggle('active');
    btn.classList.toggle('active');
  });
  document.addEventListener('click', function(e) {
    if (!btn.contains(e.target) && !nav.contains(e.target)) {
      nav.classList.remove('active');
      btn.classList.remove('active');
    }
  });
})();

/* 6. SCROLL REVEALS */
(function(){
  var revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  if (!revealEls.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
  revealEls.forEach(function(el) { observer.observe(el); });
})();

/* 7. QUIZ PERSISTENCE — Supabase returning user layer (March 27, 2026)
   Additive only. Every call wrapped in try/catch. If ANY of this fails,
   the funnel works exactly as it did before this code existed.
   ZERO modifications to quiz-engine.js, deepdive-engine.js, or report-engine.js.
   ══════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  var EDGE = 'https://nwazrnuqkauwahyshjrt.supabase.co/functions/v1/quiz-session-manager';
  var path = window.location.pathname;

  /* --- Helper: fire-and-forget POST to edge function --- */
  function saveToSupabase(data) {
    try {
      fetch(EDGE + '/save', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).catch(function() { /* silent */ });
    } catch (e) { /* silent */ }
  }

  /* ======================================================
     A. QUIZ PAGE — Save quiz results after completion
     Watches for quizData + quizEmail in localStorage
     (set by quiz-engine.js in showResults/submitEmail)
     ====================================================== */
  if (path.indexOf('brand-clarity-quiz') !== -1) {
    var quizSaved = false;
    var quizCheck = setInterval(function() {
      if (quizSaved) return;
      try {
        var qd = localStorage.getItem('quizData');
        var email = localStorage.getItem('quizEmail');
        if (qd && email) {
          quizSaved = true;
          clearInterval(quizCheck);
          var parsed = JSON.parse(qd);
          saveToSupabase({
            email: email,
            name: parsed.name || '',
            scores: {
              m: parseInt(parsed.m) || 0,
              s: parseInt(parsed.s) || 0,
              st: parseInt(parsed.st) || 0,
              p: parseInt(parsed.p) || 0,
              overall: parseInt(parsed.score) || 0,
              type: parsed.type || ''
            },
            status: 'quiz_complete'
          });
        }
      } catch (e) { /* silent */ }
    }, 1500);
    /* Clean up after 5 minutes */
    setTimeout(function() { clearInterval(quizCheck); }, 300000);
  }

  /* ======================================================
     B. DEEP DIVE PAGE — Save deep dive data before redirect
     Uses beforeunload + sendBeacon for reliable delivery
     even during page navigation. Also polls as backup.
     ====================================================== */
  if (path.indexOf('brand-blind-spot-deep-dive') !== -1) {
    var ddSaved = false;

    function buildDeepDiveSavePayload() {
      var dd = localStorage.getItem('deepDiveData');
      var email = localStorage.getItem('quizEmail');
      var qd = localStorage.getItem('quizData');
      if (!dd || !email) return null;
      var deepDive = JSON.parse(dd);
      var quiz = qd ? JSON.parse(qd) : {};
      /* Build the same URL params that deepdive-engine.js builds */
      var params = new URLSearchParams();
      params.set('name', quiz.name || '');
      params.set('score', quiz.score || '');
      params.set('m', quiz.m || '');
      params.set('s', quiz.s || '');
      params.set('st', quiz.st || '');
      params.set('p', quiz.p || '');
      params.set('type', quiz.type || '');
      params.set('email', email);
      params.set('stage', deepDive.stage || '');
      params.set('frustration', deepDive.frustration || '');
      params.set('tried', deepDive.tried || '');
      params.set('industry', deepDive.industry || '');
      params.set('goal', deepDive.goal || '');
      params.set('about', deepDive.aboutYou || '');
      params.set('bio', deepDive.currentBio || '');
      params.set('link', deepDive.linkUrl || '');
      params.set('platform', deepDive.linkPlatform || '');
      params.set('dreamclient', deepDive.dreamClient || '');
      params.set('vision', deepDive.deeperGoals || '');
      return {
        email: email,
        name: quiz.name || '',
        deep_dive: deepDive,
        report_params: params.toString(),
        status: 'deep_dive_complete'
      };
    }

    /* Backup: interval check during the 4+ second generating sequence */
    var ddCheck = setInterval(function() {
      if (ddSaved) return;
      try {
        var payload = buildDeepDiveSavePayload();
        if (payload) {
          ddSaved = true;
          clearInterval(ddCheck);
          saveToSupabase(payload);
        }
      } catch (e) { /* silent */ }
    }, 1500);
    setTimeout(function() { clearInterval(ddCheck); }, 300000);

    /* Primary: sendBeacon on page unload (fires even during redirect) */
    window.addEventListener('beforeunload', function() {
      if (ddSaved) return;
      try {
        var payload = buildDeepDiveSavePayload();
        if (payload) {
          ddSaved = true;
          var blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
          navigator.sendBeacon(EDGE + '/save', blob);
        }
      } catch (e) { /* silent */ }
    });
  }

  /* ======================================================
     C. REPORT PAGE — Two jobs:
     1. FALLBACK: If URL params are missing but email exists,
        fetch saved report data from Supabase and redirect
        with the saved params. (Fixes returning report buyers.)
     2. SAVE: After report renders, save the full URL params
        and mark session as report_generated.
     ====================================================== */
  if (path.indexOf('brand-blind-spot-report') !== -1) {
    var urlParams = new URLSearchParams(window.location.search);
    var hasScore = urlParams.get('score');
    var hasType = urlParams.get('type');
    var emailParam = urlParams.get('email');

    /* --- C1. FALLBACK: Fetch saved report for returning buyers --- */
    if (!hasScore && !hasType && emailParam) {
      try {
        fetch(EDGE + '/report?email=' + encodeURIComponent(emailParam), {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        })
        .then(function(resp) {
          if (!resp.ok) return null;
          return resp.json();
        })
        .then(function(data) {
          if (data && data.found && data.report_params) {
            /* Redirect to same page with saved params — report renders normally */
            window.location.replace(
              window.location.pathname + '?' + data.report_params
            );
          }
        })
        .catch(function() { /* silent — page loads as-is (same as today) */ });
      } catch (e) { /* silent */ }
    }

    /* --- C2. SAVE: Persist report params after render --- */
    if (hasScore && hasType) {
      var reportSaved = false;
      var reportCheck = setInterval(function() {
        if (reportSaved) return;
        try {
          var reportEl = document.getElementById('report');
          if (reportEl && reportEl.classList.contains('visible')) {
            reportSaved = true;
            clearInterval(reportCheck);
            var saveEmail = urlParams.get('email') || '';
            if (!saveEmail) {
              try { saveEmail = localStorage.getItem('quizEmail') || ''; } catch (e2) {}
            }
            if (saveEmail) {
              saveToSupabase({
                email: saveEmail,
                name: urlParams.get('name') || '',
                report_params: window.location.search.substring(1),
                status: 'report_generated'
              });
            }
          }
        } catch (e) { /* silent */ }
      }, 2000);
      /* Stop checking after 2 minutes */
      setTimeout(function() { clearInterval(reportCheck); }, 120000);
    }
  }

})();
